import { NSARouterMakerResult } from "namirasoft-account-react";
import { NSDialog, NSLabel } from "namirasoft-site-react";
import { Component } from "react";
import { ErpRouterProps } from "../ErpRouterProps";
import { ErpScope, ErpScopeField, ErpScopeMode } from "../ErpScope";
import { ErpScopeEdit } from "./ErpScopeEdit";
import Styles from "./ErpScopeView.module.css";

interface Props extends NSARouterMakerResult, ErpRouterProps
{
    mode: ErpScopeMode;
    fields: ErpScopeField[];
}

interface State
{
    company_name: string | null;
    branch_name: string | null;
    fiscal_year_name: string | null;
    company_id: string | null;
    branch_id: string | null;
    fiscal_year_id: string | null;
    dialogOpen: boolean;
}

export class ErpScopeView extends Component<Props, State>
{
    private unsubscribe: (() => void) | null = null;

    override state: State = (() =>
    {
        let s = ErpScope.get();
        return {
            company_name: s.company_name,
            branch_name: s.branch_name,
            fiscal_year_name: s.fiscal_year_name,
            company_id: s.company_id,
            branch_id: s.branch_id,
            fiscal_year_id: s.fiscal_year_id,
            dialogOpen: false,
        };
    })();

    override componentDidMount(): void
    {
        this.unsubscribe = ErpScope.subscribe(() =>
        {
            let s = ErpScope.get();
            this.setState({
                company_name: s.company_name,
                branch_name: s.branch_name,
                fiscal_year_name: s.fiscal_year_name,
                company_id: s.company_id,
                branch_id: s.branch_id,
                fiscal_year_id: s.fiscal_year_id,
            });
        });
    }

    override componentWillUnmount(): void
    {
        this.unsubscribe?.();
    }

    private partInfo(name: string | null, id: string | null): { text: string; isAll: boolean }
    {
        if (id && name)
            return { text: name, isAll: false };
        if (id)
            return { text: "…", isAll: false };
        return { text: "All", isAll: true };
    }

    private openDialog = (): void =>
    {
        if (this.props.mode === ErpScopeMode.View) return;
        this.setState({ dialogOpen: true });
    };

    private closeDialog = (): void =>
    {
        this.setState({ dialogOpen: false });
    };

    override render()
    {
        let { mode, fields } = this.props;
        let { company_name, branch_name, fiscal_year_name, company_id, branch_id, fiscal_year_id, dialogOpen } = this.state;
        let clickable = mode !== ErpScopeMode.View;
        let showCompany = fields.includes(ErpScopeField.Company);
        let showBranch = fields.includes(ErpScopeField.Branch);
        let showFiscalYear = fields.includes(ErpScopeField.FiscalYear);

        let parts: { text: string; isAll: boolean }[] = [];
        if (showCompany) parts.push(this.partInfo(company_name, company_id));
        if (showBranch) parts.push(this.partInfo(branch_name, branch_id));
        if (showFiscalYear) parts.push(this.partInfo(fiscal_year_name, fiscal_year_id));

        return (
            <>
                <div
                    title={parts.map(p => p.text).join(" - ")}
                    className={`${Styles.container} ${clickable ? Styles.clickable : ""}`}
                    onClick={clickable ? this.openDialog : undefined}
                >
                    {
                        parts.map((p, i) => (
                            <>
                                {i > 0 && <span className={Styles.sep}>-</span>}
                                <span key={i} className={Styles.segment}>
                                    <NSLabel title={p.text} classList={[p.isAll ? Styles.valueAll : Styles.value]} />
                                </span>
                            </>
                        ))
                    }
                </div>
                {
                    dialogOpen && (
                        <NSDialog onClose={this.closeDialog} center_dialog>
                            <ErpScopeEdit
                                {...this.props}
                                mode={mode}
                                fields={fields}
                                onClose={this.closeDialog}
                            />
                        </NSDialog>
                    )
                }
            </>
        );
    }
}